import React, { useEffect, useRef, useState } from "react";
import { Box, IconButton } from "@material-ui/core";
import { Image as ImageIcon, Close } from "@material-ui/icons";
import { DisplayMessage } from "../../../services/helpers";
import ImagePreviewModal from "../MediaLibrary/components/ImagePreviewModal";

export default function ImageDropzone({
  value,
  onSelect,
  onRemove,
  resources = {},
  alt = "Image",
  maxBytes = 10 * 1024 * 1024,
}) {
  const inputRef = useRef(null);
  const [objectUrl, setObjectUrl] = useState(null);
  const [previewOpen, setPreviewOpen] = useState(false);
  const [dragActive, setDragActive] = useState(false);

  useEffect(() => {
    if (value instanceof File) {
      const url = URL.createObjectURL(value);
      setObjectUrl(url);
      return () => URL.revokeObjectURL(url);
    }
    setObjectUrl(null);
    return undefined;
  }, [value]);

  const previewUrl = objectUrl || (typeof value === "string" && value ? value : null);

  const pick = (fileList) => {
    const file = fileList && fileList[0];
    if (!file) return;
    if (!file.type.startsWith("image/") || file.size > maxBytes) {
      DisplayMessage(resources["InvalidImageFile"], "error");
      return;
    }
    onSelect(file);
  };

  if (previewUrl) {
    const previewFile = { id: "image", originalContent: previewUrl, description: alt };
    return (
      <>
        <Box
          style={{
            position: "relative",
            display: "flex",
            justifyContent: "center",
            padding: "12px",
            background: "#EDF5FA",
            border: "1px dashed #53B3EA",
            borderRadius: "8px",
          }}
        >
          <img
            src={previewUrl}
            alt={alt}
            onClick={() => setPreviewOpen(true)}
            style={{
              maxHeight: "160px",
              maxWidth: "100%",
              borderRadius: "4px",
              cursor: "pointer",
            }}
          />
          <IconButton
            size="small"
            onClick={onRemove}
            style={{ position: "absolute", top: "4px", right: "4px", background: "#fff" }}
          >
            <Close fontSize="small" />
          </IconButton>
        </Box>
        <ImagePreviewModal
          open={previewOpen}
          file={previewFile}
          imageFiles={[previewFile]}
          onClose={() => setPreviewOpen(false)}
          resources={resources}
        />
      </>
    );
  }

  return (
    <Box
      onClick={() => inputRef.current && inputRef.current.click()}
      onDragEnter={(e) => {
        e.preventDefault();
        setDragActive(true);
      }}
      onDragOver={(e) => {
        e.preventDefault();
        if (!dragActive) setDragActive(true);
      }}
      onDragLeave={(e) => {
        e.preventDefault();
        setDragActive(false);
      }}
      onDrop={(e) => {
        e.preventDefault();
        setDragActive(false);
        pick(e.dataTransfer.files);
      }}
      style={{
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        gap: "8px",
        minHeight: "102px",
        padding: "0 16px",
        background: dragActive ? "#D6ECF9" : "#EDF5FA",
        border: dragActive ? "1px solid #53B3EA" : "1px dashed #53B3EA",
        borderRadius: "8px",
        cursor: "pointer",
        transition: "background 120ms ease, border-color 120ms ease",
      }}
    >
      <ImageIcon style={{ color: "#53B3EA", fontSize: "24px", pointerEvents: "none" }} />
      <div style={{ display: "flex", flexDirection: "column", gap: "4px", pointerEvents: "none" }}>
        <div style={{ fontSize: "14px", fontWeight: 500, lineHeight: "16px" }}>
          <span style={{ color: "#53B3EA" }}>{resources["Select"]}</span>{" "}
          <span style={{ color: "#212528" }}>{resources["AFile"]}</span>
        </div>
        <div style={{ fontSize: "12px", fontWeight: 500, lineHeight: "14px", color: "#5C6970" }}>
          {resources["ImageMaxSize"]}
        </div>
      </div>
      <input
        ref={inputRef}
        type="file"
        accept="image/*"
        style={{ display: "none" }}
        onChange={(e) => {
          pick(e.target.files);
          // Reset so selecting the same file again still fires onChange.
          e.target.value = "";
        }}
      />
    </Box>
  );
}
